import { useState, useEffect } from 'react';
import { supabase } from '../supabase';

const ADMIN_PASSWORD = process.env.REACT_APP_ADMIN_PASSWORD;
const DAYS = ['Mo','Tu','We','Th','Fr','Sa','Su'];
const ACCENTS = ['#1D9E75','#D85A30','#085041','#534AB7','#8B5CF6','#EC4899'];

export default function Admin({ go }) {
  const [authed, setAuthed] = useState(false);
  const [password, setPassword] = useState('');
  const [tab, setTab] = useState('nannies');
  const [nannies, setNannies] = useState([]);
  const [jobs, setJobs] = useState([]);
  const [pricing, setPricing] = useState([]);
  const [bizInfo, setBizInfo] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState('');
  const [editingNanny, setEditingNanny] = useState(null);
  const [editingJob, setEditingJob] = useState(null);
  const [showNannyForm, setShowNannyForm] = useState(false);
  const [showJobForm, setShowJobForm] = useState(false);

  const emptyNanny = { name:'', location:'', experience:'', rate:'', avatar:'', accent:'#1D9E75', bio:'', available:true, urgent:false, days:[true,true,true,true,true,false,false], specialties:[], creds:['VSC Clear','First Aid','Background checked','Child Abuse Registry'], rating:5.0, reviews:0 };
  const emptyJob = { title:'', type:'Full-time', family:'', schedule:'', rate:'', ages:'', description:'', requirements:[] };

  useEffect(() => { if(authed) fetchAll(); }, [authed]);

  async function fetchAll() {
    setLoading(true);
    const [{ data: n }, { data: j }, { data: p }, { data: b }] = await Promise.all([
      supabase.from('nannies').select('*').order('created_at'),
      supabase.from('jobs').select('*').order('created_at'),
      supabase.from('pricing').select('*').order('sort_order'),
      supabase.from('business_info').select('*'),
    ]);
    setNannies(n || []);
    setJobs(j || []);
    setPricing(p || []);
    const biz = {};
    (b || []).forEach(row => biz[row.key] = row.value);
    setBizInfo(biz);
    setLoading(false);
  }

  function showMsg(text) { setMsg(text); setTimeout(() => setMsg(''), 3000); }

  // ── NANNY CRUD ──
  async function saveNanny(data) {
    setSaving(true);
    if(data.id) {
      await supabase.from('nannies').update(data).eq('id', data.id);
    } else {
      await supabase.from('nannies').insert(data);
    }
    await fetchAll();
    setSaving(false);
    setShowNannyForm(false);
    setEditingNanny(null);
    showMsg('✅ Nanny saved!');
  }

  async function deleteNanny(id) {
    if(!window.confirm('Delete this nanny?')) return;
    await supabase.from('nannies').delete().eq('id', id);
    await fetchAll();
    showMsg('🗑️ Nanny deleted');
  }

  // ── JOB CRUD ──
  async function saveJob(data) {
    setSaving(true);
    if(data.id) {
      await supabase.from('jobs').update(data).eq('id', data.id);
    } else {
      await supabase.from('jobs').insert(data);
    }
    await fetchAll();
    setSaving(false);
    setShowJobForm(false);
    setEditingJob(null);
    showMsg('✅ Job saved!');
  }

  async function deleteJob(id) {
    if(!window.confirm('Delete this job?')) return;
    await supabase.from('jobs').delete().eq('id', id);
    await fetchAll();
    showMsg('🗑️ Job deleted');
  }

  // ── PRICING UPDATE ──
  async function savePricing(item) {
    setSaving(true);
    await supabase.from('pricing').update(item).eq('id', item.id);
    await fetchAll();
    setSaving(false);
    showMsg('✅ Pricing updated!');
  }

  // ── BIZ INFO UPDATE ──
  async function saveBizInfo() {
    setSaving(true);
    for(const [key, value] of Object.entries(bizInfo)) {
      await supabase.from('business_info').upsert({ key, value });
    }
    setSaving(false);
    showMsg('✅ Business info saved!');
  }

  // ── LOGIN ──
  if(!authed) return (
    <div style={{ minHeight:'100vh', background:'var(--teal-deeper)', display:'flex', alignItems:'center', justifyContent:'center' }}>
      <div style={{ background:'white', borderRadius:20, padding:'3rem', width:380, textAlign:'center' }}>
        <div style={{ width:56, height:56, borderRadius:'50%', background:'var(--teal)', display:'flex', alignItems:'center', justifyContent:'center', color:'white', fontFamily:"'DM Serif Display',serif", fontSize:22, margin:'0 auto 20px' }}>T</div>
        <h2 style={{ fontFamily:"'DM Serif Display',serif", fontSize:26, color:'var(--teal-deeper)', marginBottom:8 }}>Admin Panel</h2>
        <p style={{ fontSize:14, color:'var(--text-light)', marginBottom:28 }}>Tinytrust Services</p>
        <input type="password" placeholder="Enter password" value={password} onChange={e=>setPassword(e.target.value)}
          onKeyDown={e=>e.key==='Enter'&&(password===ADMIN_PASSWORD?setAuthed(true):alert('Wrong password'))}
          style={{ marginBottom:16, textAlign:'center', letterSpacing:4 }}/>
        <button className="btn-primary" style={{ width:'100%', padding:14 }}
          onClick={() => password===ADMIN_PASSWORD ? setAuthed(true) : alert('Wrong password')}>
          Login →
        </button>
      </div>
    </div>
  );

  return (
    <div style={{ background:'#f8f9fa', minHeight:'100vh' }}>
      {/* Header */}
      <div style={{ background:'var(--teal-deeper)', padding:'0 2rem', height:64, display:'flex', alignItems:'center', justifyContent:'space-between' }}>
        <div style={{ display:'flex', alignItems:'center', gap:12 }}>
          <div style={{ width:36, height:36, borderRadius:'50%', background:'var(--teal)', display:'flex', alignItems:'center', justifyContent:'center', color:'white', fontFamily:"'DM Serif Display',serif", fontSize:16 }}>T</div>
          <span style={{ fontFamily:"'DM Serif Display',serif", fontSize:18, color:'white' }}>Tinytrust <span style={{ color:'var(--coral)' }}>Admin</span></span>
        </div>
        <div style={{ display:'flex', gap:12, alignItems:'center' }}>
          {msg && <div style={{ background:'rgba(255,255,255,.15)', color:'white', padding:'6px 16px', borderRadius:20, fontSize:13 }}>{msg}</div>}
          <button onClick={() => go('home')} style={{ background:'rgba(255,255,255,.1)', border:'1px solid rgba(255,255,255,.2)', color:'white', padding:'8px 16px', borderRadius:8, fontSize:13, cursor:'pointer' }}>← View Site</button>
          <button onClick={() => setAuthed(false)} style={{ background:'var(--coral)', border:'none', color:'white', padding:'8px 16px', borderRadius:8, fontSize:13, cursor:'pointer' }}>Logout</button>
        </div>
      </div>

      {/* Tabs */}
      <div style={{ background:'white', borderBottom:'1px solid var(--border)', padding:'0 2rem', display:'flex', gap:4 }}>
        {[['nannies','👩 Nannies'],['jobs','💼 Jobs'],['pricing','💰 Pricing'],['business','📞 Business Info']].map(([id,label]) => (
          <button key={id} onClick={() => setTab(id)} style={{ padding:'16px 20px', border:'none', borderBottom:`3px solid ${tab===id?'var(--teal)':'transparent'}`, background:'none', fontSize:14, fontWeight:tab===id?600:400, color:tab===id?'var(--teal)':'var(--text-mid)', cursor:'pointer', fontFamily:"'DM Sans',sans-serif" }}>{label}</button>
        ))}
      </div>

      <div style={{ maxWidth:1100, margin:'0 auto', padding:'2rem' }}>
        {loading ? (
          <div style={{ textAlign:'center', padding:'4rem', color:'var(--text-light)' }}>Loading...</div>
        ) : (<>

          {/* ── NANNIES TAB ── */}
          {tab==='nannies' && (
            <div>
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:24 }}>
                <h2 style={{ fontFamily:"'DM Serif Display',serif", fontSize:28, color:'var(--teal-deeper)' }}>Nannies ({nannies.length})</h2>
                <button className="btn-primary" onClick={() => { setEditingNanny({...emptyNanny}); setShowNannyForm(true); }}>+ Add Nanny</button>
              </div>

              {/* Nanny list */}
              <div style={{ display:'flex', flexDirection:'column', gap:12, marginBottom:32 }}>
                {nannies.map(n => (
                  <div key={n.id} style={{ background:'white', border:'1px solid var(--border)', borderRadius:12, padding:'16px 20px', display:'flex', alignItems:'center', gap:16 }}>
                    <div style={{ width:44, height:44, borderRadius:'50%', background:n.accent, display:'flex', alignItems:'center', justifyContent:'center', color:'white', fontWeight:700, fontSize:15, flexShrink:0 }}>{n.avatar}</div>
                    <div style={{ flex:1 }}>
                      <div style={{ fontWeight:600, fontSize:15 }}>{n.name}</div>
                      <div style={{ fontSize:12, color:'var(--text-light)' }}>📍 {n.location} · {n.rate}/hr · {n.experience} yrs</div>
                    </div>
                    <div style={{ display:'flex', gap:8, alignItems:'center' }}>
                      <span style={{ background:n.available?'var(--teal-light)':'#f4f4f4', color:n.available?'var(--teal-dark)':'#aaa', borderRadius:20, padding:'4px 12px', fontSize:11, fontWeight:700 }}>{n.available?'Available':'Unavailable'}</span>
                      {n.urgent && <span style={{ background:'var(--coral-light)', color:'var(--coral)', borderRadius:20, padding:'4px 12px', fontSize:11, fontWeight:700 }}>Urgent</span>}
                      <button onClick={() => { setEditingNanny({...n}); setShowNannyForm(true); }} style={{ padding:'8px 16px', borderRadius:8, border:'1px solid var(--border)', background:'white', fontSize:13, cursor:'pointer', fontFamily:"'DM Sans',sans-serif" }}>✏️ Edit</button>
                      <button onClick={() => deleteNanny(n.id)} style={{ padding:'8px 16px', borderRadius:8, border:'1px solid #fecaca', background:'#fff5f5', color:'#dc2626', fontSize:13, cursor:'pointer', fontFamily:"'DM Sans',sans-serif" }}>🗑️</button>
                    </div>
                  </div>
                ))}
              </div>

              {/* Nanny Form Modal */}
              {showNannyForm && editingNanny && (
                <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,.5)', zIndex:200, display:'flex', alignItems:'center', justifyContent:'center', padding:'1rem' }}>
                  <div style={{ background:'white', borderRadius:20, padding:'2rem', width:'100%', maxWidth:640, maxHeight:'90vh', overflowY:'auto' }}>
                    <h3 style={{ fontFamily:"'DM Serif Display',serif", fontSize:24, color:'var(--teal-deeper)', marginBottom:24 }}>{editingNanny.id ? 'Edit' : 'Add'} Nanny</h3>
                    <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:16, marginBottom:16 }}>
                      <div><label>Full Name</label><input value={editingNanny.name} onChange={e=>setEditingNanny({...editingNanny,name:e.target.value})} placeholder="e.g. Sarah A."/></div>
                      <div><label>Location</label><input value={editingNanny.location} onChange={e=>setEditingNanny({...editingNanny,location:e.target.value})} placeholder="e.g. NW Calgary"/></div>
                      <div><label>Rate (e.g. $20–$25)</label><input value={editingNanny.rate} onChange={e=>setEditingNanny({...editingNanny,rate:e.target.value})} placeholder="$20–$25"/></div>
                      <div><label>Experience (years)</label><input value={editingNanny.experience} onChange={e=>setEditingNanny({...editingNanny,experience:e.target.value})} placeholder="e.g. 5+"/></div>
                      <div><label>Avatar Initials</label><input value={editingNanny.avatar} onChange={e=>setEditingNanny({...editingNanny,avatar:e.target.value})} placeholder="e.g. SA" maxLength={2}/></div>
                      <div>
                        <label>Avatar Colour</label>
                        <div style={{ display:'flex', gap:8, marginTop:4 }}>
                          {ACCENTS.map(c => (
                            <div key={c} onClick={() => setEditingNanny({...editingNanny,accent:c})} style={{ width:28, height:28, borderRadius:'50%', background:c, cursor:'pointer', border:editingNanny.accent===c?'3px solid #333':'2px solid transparent' }}/>
                          ))}
                        </div>
                      </div>
                    </div>
                    <div style={{ marginBottom:16 }}><label>Bio</label><textarea rows={3} value={editingNanny.bio} onChange={e=>setEditingNanny({...editingNanny,bio:e.target.value})} placeholder="Short bio about the nanny..." style={{ resize:'vertical' }}/></div>
                    <div style={{ marginBottom:16 }}>
                      <label>Specialties (comma separated)</label>
                      <input value={Array.isArray(editingNanny.specialties)?editingNanny.specialties.join(', '):editingNanny.specialties} onChange={e=>setEditingNanny({...editingNanny,specialties:e.target.value.split(',').map(s=>s.trim()).filter(Boolean)})} placeholder="After school, CPR certified, Urgent available"/>
                    </div>
                    <div style={{ marginBottom:16 }}>
                      <label>Available Days</label>
                      <div style={{ display:'flex', gap:8, marginTop:8 }}>
                        {DAYS.map((d,i) => (
                          <div key={d} onClick={() => { const days=[...editingNanny.days]; days[i]=!days[i]; setEditingNanny({...editingNanny,days}); }} style={{ width:36, height:36, borderRadius:8, display:'flex', alignItems:'center', justifyContent:'center', fontSize:11, fontWeight:700, cursor:'pointer', background:editingNanny.days[i]?'var(--teal)':'#f4f4f4', color:editingNanny.days[i]?'white':'#aaa' }}>{d}</div>
                        ))}
                      </div>
                    </div>
                    <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:16, marginBottom:24 }}>
                      <div style={{ display:'flex', alignItems:'center', gap:10, padding:'12px 16px', background:editingNanny.available?'var(--teal-light)':'#f4f4f4', borderRadius:10, cursor:'pointer' }} onClick={() => setEditingNanny({...editingNanny,available:!editingNanny.available})}>
                        <div style={{ width:20, height:20, borderRadius:'50%', background:editingNanny.available?'var(--teal)':'#ccc', display:'flex', alignItems:'center', justifyContent:'center', color:'white', fontSize:12 }}>{editingNanny.available?'✓':''}</div>
                        <span style={{ fontSize:14, fontWeight:600, color:editingNanny.available?'var(--teal-dark)':'#666' }}>Available</span>
                      </div>
                      <div style={{ display:'flex', alignItems:'center', gap:10, padding:'12px 16px', background:editingNanny.urgent?'var(--coral-light)':'#f4f4f4', borderRadius:10, cursor:'pointer' }} onClick={() => setEditingNanny({...editingNanny,urgent:!editingNanny.urgent})}>
                        <div style={{ width:20, height:20, borderRadius:'50%', background:editingNanny.urgent?'var(--coral)':'#ccc', display:'flex', alignItems:'center', justifyContent:'center', color:'white', fontSize:12 }}>{editingNanny.urgent?'✓':''}</div>
                        <span style={{ fontSize:14, fontWeight:600, color:editingNanny.urgent?'var(--coral)':'#666' }}>Urgent Available</span>
                      </div>
                    </div>
                    <div style={{ display:'flex', gap:12 }}>
                      <button className="btn-primary" style={{ flex:1, padding:14 }} onClick={() => saveNanny(editingNanny)} disabled={saving}>{saving?'Saving...':'Save Nanny'}</button>
                      <button className="btn-outline" style={{ flex:1, padding:14 }} onClick={() => { setShowNannyForm(false); setEditingNanny(null); }}>Cancel</button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}

          {/* ── JOBS TAB ── */}
          {tab==='jobs' && (
            <div>
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:24 }}>
                <h2 style={{ fontFamily:"'DM Serif Display',serif", fontSize:28, color:'var(--teal-deeper)' }}>Jobs ({jobs.length})</h2>
                <button className="btn-primary" onClick={() => { setEditingJob({...emptyJob}); setShowJobForm(true); }}>+ Add Job</button>
              </div>
              <div style={{ display:'flex', flexDirection:'column', gap:12, marginBottom:32 }}>
                {jobs.map(j => (
                  <div key={j.id} style={{ background:'white', border:'1px solid var(--border)', borderRadius:12, padding:'16px 20px', display:'flex', alignItems:'center', gap:16 }}>
                    <div style={{ flex:1 }}>
                      <div style={{ fontWeight:600, fontSize:15 }}>{j.title}</div>
                      <div style={{ fontSize:12, color:'var(--text-light)', marginTop:2 }}>{j.family} · {j.schedule} · {j.rate}</div>
                    </div>
                    <span style={{ background:j.type==='Urgent'?'var(--coral-light)':'var(--teal-light)', color:j.type==='Urgent'?'var(--coral)':'var(--teal-dark)', borderRadius:20, padding:'4px 12px', fontSize:11, fontWeight:700 }}>{j.type}</span>
                    <button onClick={() => { setEditingJob({...j}); setShowJobForm(true); }} style={{ padding:'8px 16px', borderRadius:8, border:'1px solid var(--border)', background:'white', fontSize:13, cursor:'pointer', fontFamily:"'DM Sans',sans-serif" }}>✏️ Edit</button>
                    <button onClick={() => deleteJob(j.id)} style={{ padding:'8px 16px', borderRadius:8, border:'1px solid #fecaca', background:'#fff5f5', color:'#dc2626', fontSize:13, cursor:'pointer', fontFamily:"'DM Sans',sans-serif" }}>🗑️</button>
                  </div>
                ))}
              </div>

              {/* Job Form Modal */}
              {showJobForm && editingJob && (
                <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,.5)', zIndex:200, display:'flex', alignItems:'center', justifyContent:'center', padding:'1rem' }}>
                  <div style={{ background:'white', borderRadius:20, padding:'2rem', width:'100%', maxWidth:580, maxHeight:'90vh', overflowY:'auto' }}>
                    <h3 style={{ fontFamily:"'DM Serif Display',serif", fontSize:24, color:'var(--teal-deeper)', marginBottom:24 }}>{editingJob.id?'Edit':'Add'} Job</h3>
                    <div style={{ marginBottom:16 }}><label>Job Title</label><input value={editingJob.title} onChange={e=>setEditingJob({...editingJob,title:e.target.value})} placeholder="e.g. Full-time nanny needed"/></div>
                    <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:16, marginBottom:16 }}>
                      <div>
                        <label>Type</label>
                        <select value={editingJob.type} onChange={e=>setEditingJob({...editingJob,type:e.target.value})}>
                          {['Full-time','Part-time','Urgent'].map(t=><option key={t}>{t}</option>)}
                        </select>
                      </div>
                      <div><label>Family Location</label><input value={editingJob.family} onChange={e=>setEditingJob({...editingJob,family:e.target.value})} placeholder="e.g. Family in NW Calgary"/></div>
                      <div><label>Schedule</label><input value={editingJob.schedule} onChange={e=>setEditingJob({...editingJob,schedule:e.target.value})} placeholder="e.g. Mon–Fri, 7am–5pm"/></div>
                      <div><label>Rate</label><input value={editingJob.rate} onChange={e=>setEditingJob({...editingJob,rate:e.target.value})} placeholder="e.g. $22–$25/hr"/></div>
                      <div><label>Children's Ages</label><input value={editingJob.ages} onChange={e=>setEditingJob({...editingJob,ages:e.target.value})} placeholder="e.g. Ages 4 & 7"/></div>
                    </div>
                    <div style={{ marginBottom:16 }}><label>Description</label><textarea rows={3} value={editingJob.description} onChange={e=>setEditingJob({...editingJob,description:e.target.value})} style={{ resize:'vertical' }}/></div>
                    <div style={{ marginBottom:24 }}>
                      <label>Requirements (comma separated)</label>
                      <input value={Array.isArray(editingJob.requirements)?editingJob.requirements.join(', '):editingJob.requirements} onChange={e=>setEditingJob({...editingJob,requirements:e.target.value.split(',').map(s=>s.trim()).filter(Boolean)})} placeholder="CPR required, Driver's licence, Background check"/>
                    </div>
                    <div style={{ display:'flex', gap:12 }}>
                      <button className="btn-primary" style={{ flex:1, padding:14 }} onClick={() => saveJob(editingJob)} disabled={saving}>{saving?'Saving...':'Save Job'}</button>
                      <button className="btn-outline" style={{ flex:1, padding:14 }} onClick={() => { setShowJobForm(false); setEditingJob(null); }}>Cancel</button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}

          {/* ── PRICING TAB ── */}
          {tab==='pricing' && (
            <div>
              <h2 style={{ fontFamily:"'DM Serif Display',serif", fontSize:28, color:'var(--teal-deeper)', marginBottom:24 }}>Pricing Cards</h2>
              <div style={{ display:'flex', flexDirection:'column', gap:16 }}>
                {pricing.map(p => (
                  <div key={p.id} style={{ background:'white', border:'1px solid var(--border)', borderRadius:12, padding:'1.5rem' }}>
                    <div style={{ display:'flex', alignItems:'center', gap:12, marginBottom:16 }}>
                      <span style={{ fontSize:28 }}>{p.icon}</span>
                      <h4 style={{ fontWeight:700, fontSize:16, color:'var(--teal-deeper)' }}>{p.type}</h4>
                      {p.popular && <span style={{ background:'var(--teal)', color:'white', borderRadius:6, padding:'2px 10px', fontSize:11, fontWeight:700 }}>MOST POPULAR</span>}
                    </div>
                    <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:16, marginBottom:16 }}>
                      <div><label>Price (e.g. $18–$25)</label><input value={p.price} onChange={e=>setPricing(pricing.map(x=>x.id===p.id?{...x,price:e.target.value}:x))}/></div>
                      <div><label>Unit (e.g. per hour)</label><input value={p.unit} onChange={e=>setPricing(pricing.map(x=>x.id===p.id?{...x,unit:e.target.value}:x))}/></div>
                    </div>
                    <div style={{ marginBottom:16 }}><label>Description</label><input value={p.description} onChange={e=>setPricing(pricing.map(x=>x.id===p.id?{...x,description:e.target.value}:x))}/></div>
                    <div style={{ marginBottom:16 }}>
                      <label>Features (comma separated)</label>
                      <input value={Array.isArray(p.features)?p.features.join(', '):p.features} onChange={e=>setPricing(pricing.map(x=>x.id===p.id?{...x,features:e.target.value.split(',').map(s=>s.trim()).filter(Boolean)}:x))}/>
                    </div>
                    <button className="btn-primary" style={{ padding:'10px 24px' }} onClick={() => savePricing(p)} disabled={saving}>{saving?'Saving...':'Save Changes'}</button>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* ── BUSINESS INFO TAB ── */}
          {tab==='business' && (
            <div style={{ maxWidth:560 }}>
              <h2 style={{ fontFamily:"'DM Serif Display',serif", fontSize:28, color:'var(--teal-deeper)', marginBottom:24 }}>Business Info</h2>
              <div style={{ background:'white', border:'1px solid var(--border)', borderRadius:12, padding:'2rem' }}>
                {[['phone','📞 Phone Number'],['email','📧 Main Email'],['email_founder','📧 Founder Email'],['licence','🪪 Licence Number'],['address','📍 Address']].map(([key,label]) => (
                  <div key={key} style={{ marginBottom:20 }}>
                    <label>{label}</label>
                    <input value={bizInfo[key]||''} onChange={e=>setBizInfo({...bizInfo,[key]:e.target.value})}/>
                  </div>
                ))}
                <button className="btn-primary" style={{ width:'100%', padding:14, fontSize:15 }} onClick={saveBizInfo} disabled={saving}>{saving?'Saving...':'Save Business Info'}</button>
              </div>
            </div>
          )}

        </>)}
      </div>
    </div>
  );
}